import ApiService from '../services/api';
import ActionTemplate from './services/actionTemplate';

const GET_TOKENIZATION_REQUESTS = 'GET_TOKENIZATION_REQUESTS';
/** Actions for Tokenization Request */
export default class TokenizationRequestAction {

    constructor() {
        this.api = new ApiService();
        this.actionTemplate = new ActionTemplate();
    }

    /**********************************************************/
    /*******************TOKENIZATION REQUEST*******************/
    /**********************************************************/

    getTokenizationRequests(token){
        return (dispatch) => {
            dispatch(this.actionTemplate.request(GET_TOKENIZATION_REQUESTS));
            const url = `/tokenization_requests/${token}`;
            return this.api.get(url)
                .then((response) => {
                    if (response.data){
                        dispatch(this.actionTemplate.success(GET_TOKENIZATION_REQUESTS, response.data));
                    } else {
                        dispatch(this.actionTemplate.failure(GET_TOKENIZATION_REQUESTS, response.error));
                    }
                })
                .catch((err) => {
                    /* istanbul ignore next */ 
                    dispatch(this.actionTemplate.failure(GET_TOKENIZATION_REQUESTS, err));
                });
        };
    }
}
